import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  { name: "Priya Sharma", image: "/images/testimonials/priya-sharma.webp", text: "Absolutely loved the balloon decoration! It made my son's birthday magical." },
  { name: "Rohit Verma", image: "/images/testimonials/rohit-verma.webp", text: "DecorZoom transformed our celebration space with their amazing balloon work!" },
  { name: "Neha Gupta", image: "/images/testimonials/neha-gupta.webp", text: "They really understood the jungle theme and delivered beautifully!" },
  { name: "Karan Mehta", image: "/images/testimonials/karan-mehta.webp", text: "Balloon arch and photo booth were perfect for the baby shower." },
  { name: "Sneha Reddy", image: "/images/testimonials/sneha-reddy.webp", text: "Loved the Barbie theme decoration, my daughter was super happy!" },
  { name: "Amit Saini", image: "/images/testimonials/amit-saini.webp", text: "Booked DecorZoom for anniversary decoration — beautiful!" },
  { name: "Meena Joshi", image: "/images/testimonials/meena-joshi.webp", text: "Balloons, flowers, lights — perfect combo." },
  { name: "Ankit Thakur", image: "/images/testimonials/ankit-thakur.webp", text: "Cold pyro + balloon entrance was dhamakedaar!" },
  { name: "Pooja Mishra", image: "/images/testimonials/pooja-mishra.webp", text: "Very professional and creative decoration for baby welcome." },
  { name: "Vikas Chauhan", image: "/images/placeholder.png", text: "Highly creative team. Setup was top-notch!" },
];

const TestimonialSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="py-12 bg-white px-4">
      <h2 className="text-3xl font-bold text-center mb-10">What Our Clients Say</h2>
      <div className="max-w-6xl mx-auto">
        <Slider {...settings}>
          {testimonials.map((t, idx) => (
            <div key={idx} className="px-4">
              <div className="bg-gray-100 rounded-lg shadow-lg p-6 text-center">
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-20 h-20 mx-auto rounded-full object-cover mb-4 border-4 border-pink-400"
                />
                <p className="text-gray-700 italic mb-3">"{t.text}"</p>
                <h4 className="text-lg font-semibold text-pink-600">{t.name}</h4>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default TestimonialSlider;
